import { Component, Input, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'ngx-observacao-importacao-funcionario',
  templateUrl: 'observacao-importacao-funcionario.component.html',
  styleUrls: ['observacao-importacao-funcionario.component.scss'],
})
export class ObservacaoImportacaoFuncionarioComponent implements OnInit {

  @Input() content: string;

  @ViewChild("card", null)
  private card: ElementRef

  constructor(protected ref: NbDialogRef<ObservacaoImportacaoFuncionarioComponent>) {}

  ngOnInit(){
    this.card.nativeElement.ownerDocument.activeElement.blur();

  }

  dismiss() {
    this.ref.close();
  }
}
